import React from 'react';
import styles from './Performance.module.css';

interface YDNDComponent extends React.FC {
  title?: string;
}

const YDND: YDNDComponent = () => {
  return (
    <div>
      <div className={styles.metricSection}>
        <strong>Metric Descriptions</strong>
        <ul>
          <li>Cumulative Subscriptions: the number of active subscriptions associated with your store since the launch of the Yard RX program</li>
          <li>Cumulative Projected Sales w/ add-ons: the total amount of sales for subscriptions to include any one-time purchase products since the launch of the Yard RX program; customers are billed once the subscription delivery products either leave the warehouse (ship to store goods) or the stock is validated (in-store pick goods)</li>
          <li>Cumulative Projected Sales w/o add-ons: the amount of sales for the base subscription products since the launch of the Yard RX program; customers are billed once the subscription delivery products either leave the warehouse (ship to store goods) or the stock is validated (in-store pick goods)</li>
          <li>YTD Projected Sales w/ add-ons: the total amount of sales for subscriptions plus any one-time purchase products in the current year; customers are billed once the subscription delivery products either leave the warehouse (ship to store goods) or the stock is validated (in-store pick goods)</li>
          <li>YTD Projected Sales w/o add-ons: the amount of sales for the base subscription products in the current year; customers are billed once the subscription delivery products either leave the warehouse (ship to store goods) or the stock is validated (in-store pick goods)</li>
          <li>YTD Projected Instant Savings: the amount of instant savings dollars associated with the items in the base subscription in the current year</li>
          <li>YTD Projected Units w/ add-ons: the number of units in the base subscription plus any one-time purchase items in the current year</li>
          <li>YTD Projected Units w/o add-ons: the number of units in the base subscription only in the current year</li>
          <li>Deliveries within 90 days: a view into the upcoming subscription deliveries that will occur within the next 90 days; these subscription orders will appear in Customer Orders 14 days prior to the maximum promised delivery date. Once the link is clicked, you may choose to run the report at the order level or the SKU level.</li>
        </ul>
      </div>

      <div className={styles.metricSection}>
        <strong>Update Cadence</strong>
        <p>
          All metrics are updated daily.
        </p>
      </div>
    </div>
  );
};

YDND.title = 'Yard RX';
export default YDND;
